// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26HKF","left":"styles_left__3Nl3I"};